<template>
  <div class="class-information-success">
      <h3>恭喜您完成入学报到<br/>记得添加班主任领取入学资料哦~</h3>
  </div>
</template>

<script>
export default {
    data(){
        return{

        }
    },
    methods:{
        pullData(){
            document.title = this.$route.query.title;
        }
    },
    created(){
        this.pullData();
    }
}
</script>

<style lang="scss" scoped>
.class-information-success{
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: #ffffff;
    h3{
        margin-top: 445px;
        text-align: center;
        font-size: 32px;
        color: #333333;
        letter-spacing: 3px;
    }
}
</style>